import AnalyticsEvent from './analytics-event';
import { ConversationProperty, createConversationProperty } from '../properties/conversation-property';
import { Conversation } from '@monolith/legacy/types/conversation';

export default class MessageRepliedEvent extends AnalyticsEvent {
  public readonly name = 'Message Replied';
  public properties: {
    conversation: ConversationProperty;
  };

  constructor(message: Conversation) {
    super();
    this.properties = {
      conversation: createConversationProperty(message),
    };
  }
}
